<template>
  <v-col class="pa-5">
    <h2>{{ $translate('DUTCHSTAMPS') }}</h2>
    <v-card elevation="0" class="transparent mt-4">
      <v-card
        class="pa-4 mb-4"
        outlined
        v-for="(stampSet, index) in dutchStamps"
        :key="`stamp-set-${index}`"
      >
        <strong>{{ stampSet.PartnerName }}</strong>
        <p class="hidden-xs-only">
          {{ $translate('YOU_HAVE') }}
          <a class="font-weight-bold black--text"
            >{{ stampSet.Amount }} / {{ stampSet.FullAmount }}</a
          >
          {{ $translate('DUTCHSTAMPS') }}
        </p>
        <v-row class="hidden-xs-only">
          <v-col
            class="ma-0 pa-0"
            cols="12"
            :md="mdStamps"
            :lg="lgStamps"
            :xl="xlStamps"
          >
            <v-avatar
              v-for="(item, i) in stampSet.Amount"
              :key="`stamp-set-${index}-item-${i}`"
              class="ma-2 rounded-lg"
              size="46"
              tile
              color="primary"
            >
              <v-img :src="require('../../assets/Buy Fresh.png')" />
            </v-avatar>
            <v-avatar
              v-for="(item, i) in stampSet.FullAmount - stampSet.Amount"
              :key="`stamp-set-${index}-empty-${i}`"
              class="ma-2 rounded-lg"
              size="46"
              tile
              color="grey lighten-2"
            >
              <a class="grey--text">{{ i + stampSet.Amount + 1 }}</a>
            </v-avatar>
          </v-col>
        </v-row>
        <v-row class="hidden-sm-and-up">
          <v-col justify="center" align="center">
            <v-avatar class="" size="70" color="primary">
              <v-img :src="require('../../assets/Buy Fresh.png')" />
            </v-avatar>
            <br />
            <a class="black--text font-weight-bold">
              {{ stampSet.Amount }} / {{ stampSet.FullAmount }}
            </a>
          </v-col>
        </v-row>
        <div v-if="stampSet.Fullcards > 0">
          <p class="mt-4">{{ $translate('REDEEM_EXPL') }}</p>
          <p class="mt-4">
            {{ $translate('YOU_HAVE') }}
            <a class="font-weight-bold black--text">{{ stampSet.Fullcards }}</a>
            {{ $translate('FULL_CARDS') }}
          </p>
          <v-card-actions>
            <v-row>
              <v-btn
                color="primary"
                :loading="loading"
                @click="convertDutchStampsToUserCredit(stampSet)"
              >
                {{ $translate('REDEEM') }}
              </v-btn>
            </v-row>
          </v-card-actions>
        </div>
      </v-card>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex';
import doRequest from '@/api/dssRequest';

export default {
  name: 'UserSettingsDutchStamps',
  components: {},
  computed: {
    ...mapGetters({
      dutchStamps: 'auth/dutchStamps',
    }),
  },
  data() {
    return {
      loading: false,
      smStamps: 0,
      mdStamps: 0,
      lgStamps: 0,
      xlStamps: 0,
    };
  },
  mounted() {
    this.checkAmountOfStamps();
  },
  methods: {
    checkAmountOfStamps() {
      if (this.dutchStamps[0].FullAmount <= 20) {
        this.mdStamps = 6;
        this.lgStamps = 5;
        this.xlStamps = 4;
      } else if (this.dutchStamps[0].FullAmount <= 50) {
        this.mdStamps = 9;
        this.lgStamps = 8;
        this.xlStamps = 7;
      } else if (this.dutchStamps[0].FullAmount <= 80) {
        this.mdStamps = 10;
        this.lgStamps = 9;
        this.xlStamps = 8;
      } else if (this.dutchStamps[0].FullAmount <= 100) {
        this.mdStamps = 12;
        this.lgStamps = 12;
        this.xlStamps = 12;
      }
    },
    convertDutchStampsToUserCredit(stampSet) {
      this.loading = true;
      const payload = {
        NumberOfCards: stampSet.Fullcards,
        PartnerId: stampSet.PartnerId,
      };
      doRequest(
        (response) => {
          window.EventBus.fire('getUserData');
          this.loading = false;
        },
        (error) => {
          window.EventBus.fire('getUserData');
          this.loading = false;
        },
        'convertDutchStampsToUserCredit',
        this.$store.getters['auth/userName'],
        payload
      );
    },
  },
};
</script>
<style scoped lang="scss"></style>
